import { FILTER_CONTEXT_LABELS, FILTER_CONTEXTS } from "@search/api/constants";
import BooleanFilter from "@search/store/filters/primitive/BooleanFilter";

class ToursFilter extends BooleanFilter {
  constructor(value: boolean) {
    super({
      defaultValue: false,
      label: FILTER_CONTEXT_LABELS[FILTER_CONTEXTS.tours],
      name: "tours",
      value,
    });
  }
}

export default ToursFilter;
export { ToursFilter };
